<template>
  <div class="">
    <div class="flex flex-wrap justify-between mb-30 mb-db mb-tc">
      <h2 class="fs-32 fw-700 ink mb-fs-28">{{ countryName }} Travel Inspiration</h2>
      <div class="mb-dn">
        <a :href="toBlogPage" class="button button-outline fs-14 fw-500 lh-16 hand" target="_blank"> See All Posts </a>
      </div>
    </div>
    <div class="overflow-auto">
      <div class="flex mb-5 mb-mb-30">
        <div class="item wp-33-3 mb-wp-100" v-for="(item, index) in listBlogPost" :key="index">
          <div class="h-170 relative mb-21 hand overflow-hidden br-8">
            <a :href="item.link" :title="item.title" target="_blank">
              <div class="absolute wp-100 hp-100 z-2 bg-linear-gradient-2"></div>
              <img loading="lazy" class="img-cover" :src="item.thumbnail" alt="" />
              <div class="absolute z-3 bottom-0 left-0 right-0 cream pb-20 pl-20 pr-20 fs-20 lh-1 fw-700 mb-fs-16">
                {{ item.title }}
              </div>
            </a>
          </div>
          <div class="pl-20 pr-20">
            <div class="fw-500 fs-13 mb-20 muted-sand">
              <span class="mr-20 dib lh-15"
                >written by <span class="brand-green">{{ item.author }}</span></span
              >
              <span class="dib lh-15">{{ formatDate(item.date, 'm d Y') }}</span>
            </div>
            <div class="fs-16 lh-24 di text-excerpt" v-html="item.content"></div>
            <a :href="item.link" target="_blank"><span class="read-more-link fw-500 hand fs-16">read more</span></a>
          </div>
        </div>
      </div>
    </div>
    <div class="dn mb-db tc">
      <a :href="toBlogPage" class="button button-outline fs-14 fw-500 lh-16 hand"> See All Posts </a>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import galleryApi from '~/composables/api/galleryApi'
import { formatDate } from '~/helper'

// ---Props & Emit---
const props = defineProps({
  category: {
    type: String,
    required: true,
  },
  countryName: {
    type: String,
    required: true,
  },
})
const emit = defineEmits(['hiddenBlog'])

// ---Define---
const listBlogPost = ref([])

// ---Computed
const toBlogPage = computed(() => {
  return useRuntimeConfig().public.publicDomain + `/blog/category/${props.category}/`
})

// ---Method
const getBlogPost = async () => {
  let category = props.category
  const repCategory = category.replace(/-and/g, '')
  let params = {
    category: repCategory,
    limit: 3,
  }
  try {
    const { data: res } = await galleryApi.getBlogPost(params)
    listBlogPost.value = res.value.data
    emit('hiddenBlog', listBlogPost.value.length)
  } catch (e) {
    emit('hiddenBlog', 0)
    console.log(e)
  }
}

// ---Watch---
// watch(
//   () => props.category,
//   async () => {
//     listBlogPost.value = []
//     await getBlogPost()
//   },
// )

// ---Mouted---
onMounted(()=>{
  nextTick(()=> getBlogPost())
})
</script>
<style lang="scss" scoped>
.item {
}
h2 {
  letter-spacing: -0.04em; // v2 display tracking (§Typography Scale L94–96)
}
.text-excerpt {
  :deep(p:last-child) {
    line-height: 24px; // §8 body 1.5
  }
}

// (Green photography-overlay removed 2026-07-15, product decision — post thumbs
// keep the original neutral .bg-linear-gradient-2 bottom fade for title legibility.)

// §9 text link — green, no resting underline; gold + underline on hover
.read-more-link {
  color: $link;
  text-decoration: none;
  transition: color $dur-fast $ease-out;
  &:hover {
    color: $link-strong; // v2 §7/§Link — darken (gold text on cream fails AA); underline stays
    text-decoration: underline;
  }
}
.item {
  margin-right: 40px;
  &:last-child {
    margin-right: 0;
  }
  @media (min-width: 600px) and (max-width: 900px) {
    width: 50%;
    margin-right: 0;
    &:last-child {
      display: none;
    }
    &:first-child {
      margin-right: 20px;
      display: block;
    }
  }
  @media (max-width: 599px) {
    display: none;
    &:first-child {
      display: block;
      margin-right: 0;
    }
  }
}
</style>
